<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list"></i>
          <strong>
            {{ title }}
            <b-spinner v-if="loading" class="float-right" small />
          </strong>
        </div>
        <div>
          <stock-list
            :title="title"
            :column_display="column_display"
            :columns="returnColumns"
            :filterable="filterable"
            :list-columns="listColumns"
            :dwn-json-fields="dwnJsonFields"
            :headings="headings"
            :url="url"
            @on-loading="loading = $event"
          />
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import StockList from "../../bagno_views/ServerFilterableTable";
import moment from "moment";

export default {
  name: "TimeControlList",
  components: {
    StockList
  },
  data() {
    return {
      title: "Control de tiempos",
      loading: false,
      column_display: {
        product_family: "not_desktop",
        product_fruit: "not_desktop",
        "product_type.name": "not_desktop",
        lot: "",
        product_code: "",
        product: "",
        number: "",
        quantity: "",
        container: "",
        creation_date: "not_desktop",
        net_kilograms: "",
        gross_kilograms: "",
        position: "not_desktop"
      },
      columns: [
        "status.status_name",
        "pallet_number",
        "created_by",
        "tolerancia"
      ],
      filterable: ["pallet_number", "status.status_name"],
      headings: {
        "status.status_name": "Zona",
        pallet_number: "Pallet",
        created_by: "Registrado por",
        entered_at: "Ingreso",
        left_at: "Salida"
      },
      listColumns: {
        "status.status_name": []
      },
      dwnJsonFields: {
        "status.status_name": "Zona",
        pallet_number: "Pallet",
        elapsed_time: "Periodo en Segundos",
        es_colors: "Tolerancia",
        created_by: "Registrado por",
        h_entered_at: "Ingreso",
        h_left_at: "Salida"
      },
      statuses: {}
    };
  },
  mounted() {
    this.getListColumns();
  },
  computed: {
    returnColumns() {
      let colms = [
        "status.status_name",
        "pallet_number",
        "created_by",
        "tolerancia"
      ];
      this.$attrs.all_history ? colms.push("entered_at", "left_at") : true;
      return colms;
    },
    stock_area_filter_constructor() {
      let filter = this.$route.params;
      filter = !_.isEmpty(filter)
        ? filter.process_type_complete.stockarea_set
            .map((e) => e.id)
            .join("|stock_area=")
        : "";
      return "stock_area=" + filter;
    },
    url() {
      return (
        "/v1/timecontrol/status/pallets/?paginated=true&all_history=" +
        this.$attrs.all_history
      );
    }
  },
  methods: {
    rowClassCallback() {
      return "table-warning";
    },
    getListColumns() {
      this.$axios
        .get("/v1/timecontrol/status/")
        .then((res) => {
          res.data.map((a) => {
            let object = {
              id: a.id,
              text: a.status_name
            };
            this.listColumns["status.status_name"].push(object);
          });

          this.statuses = res.data;
        })
        .catch((error) => console.log(error));
    }
  }
};
</script>

<style scoped></style>
